import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedDate, FormattedTime } from 'components/intl'
import { get } from 'lodash'

import { AccordionToggle } from 'components/misc'
import { Section } from 'components/layout'
import { Table, Data } from 'components/layout/Table'
import { histories as historiesLayout } from 'constants/layout'
import styles from './history.styl'
import config from 'config'

export default class History extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    onGetActions: PropTypes.func.isRequired,
    setActionsParams: PropTypes.func.isRequired,
    showAccordion: PropTypes.bool
  }

  static defaultProps = { showAccordion: false }

  state = { isVisible: false }

  componentDidMount() {
    !this.props.showAccordion && this.props.onGetActions(this.props.actions)
  }

  handleParseParameter = (summary, params) => {
    const regex = /\{(.*?)\}/g

    if(!summary){
      return
    }

    summary = summary.replace(/\n|\r/g, '')
    return summary.replace(regex, (a, b) => this.handleParamJoin(b, params))
  }

  handleParamJoin = string => {
    const splittedString = string.split(' ')

    const classKey = splittedString[0]

    if (classKey === 'oldPaymentState' || classKey === 'paymentState') {
      return `<strong>${splittedString
        .slice(1, splittedString.length)
        .join(' ')}</strong>`
    }

    if(classKey === 'personalReflection'){
      splittedString.shift()
      splittedString.push(' ')
      return `<span>${splittedString.join(' ')}</span>`
    }

    let entity = splittedString.slice(2, splittedString.length).join(' ')

    if (
      classKey === 'note' ||
      classKey === 'name' ||
      classKey === 'paymentDate' ||
      classKey === 'paymentType' ||
      classKey === 'transaction'
    ) {
      entity = splittedString.slice(1, splittedString.length).join(' ')
    }

    if (classKey === 'participant') {
      let participantId = splittedString.slice(1, splittedString.length)[0]

      return `<a class=${styles[classKey]} href="${config.publicPath}/participants/${participantId}/detail"><span class=${styles[classKey]}>${entity}</span></a>`
    }

    if (classKey === 'oldValue' || classKey === 'newValue') {
      let content = string.replace('oldValue ','').replace('newValue ','')

      return `<div class=${styles.email}><p>${content}</p></div>`
    }

    return `<span class=${styles[classKey]}>${entity}</span>`
  }

  handleToggle = () => {
    if (!this.props.actions.list.length) {
      this.props.onGetActions()
    }

    this.setState({ isVisible: !this.state.isVisible })
  }

  render() {
    const {
      actions: { loading, list, offset, limit, pages, sort },
      showAccordion,
      setActionsParams
    } = this.props

    // if (onlyNotes) {
    //   list = list.filter(item => item.note)
    // }
    return (
      <Section>
        {showAccordion &&
          <AccordionToggle
            isActive={this.state.isVisible}
            onClick={this.handleToggle}
            intlKey="moduleTitle.history"
          >
            History
          </AccordionToggle>}

        {(this.state.isVisible || !showAccordion) &&
          <div className={styles.history}>
            <Table
              ths={historiesLayout.tableHeaders}
              loading={loading}
              length={list.length}
              offset={offset}
              limit={limit}
              pages={pages}
              sort={sort}
              setParams={setActionsParams}
            >
              <Data>
                {list.map(({
                  id,
                  creationDate,
                  createdAt,
                  summary,
                  organization,
                  author,
                  person,
                  award,
                  note
                }) => (

                  <tr key={id}>
                    <td className={styles.date}>
                      {createdAt && <FormattedDate timeZone="UTC" value={createdAt} spaceAfter />}
                      {' '}
                      {createdAt && <FormattedTime timeZone="UTC" value={createdAt} />}
                    </td>
                    <td className={styles.date}>
                      {creationDate && <FormattedDate value={creationDate} spaceAfter />}
                      {' '}
                      {creationDate && <FormattedTime value={creationDate} />}
                    </td>
                    <td
                      className={styles.description}
                      dangerouslySetInnerHTML={{
                        __html: this.handleParseParameter(summary, {
                          organizationId: get(organization, 'id'),
                          authorId: get(author, 'id'),
                          personId: get(person, 'id'),
                          awardId: get(award, 'id'),
                          note
                        })
                      }}
                    />
                  </tr>
                ))}
              </Data>
            </Table>
          </div>}
      </Section>
    )
  }
}
